import { render, staticRenderFns } from "./inbdmain.vue?vue&type=template&id=4423807f&scoped=true"
import script from "./inbdmain.vue?vue&type=script&lang=js"
export * from "./inbdmain.vue?vue&type=script&lang=js"
import style0 from "./inbdmain.vue?vue&type=style&index=0&id=4423807f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423807f",
  null
  
)

export default component.exports